import type { ConsoleId } from '@/views/merchant/registry/consoles'
import { getConsole } from '@/views/merchant/registry/consoles'
import { STORE_BASE, storePath } from '@/views/merchant/registry/paths'

const K_CONSOLE = 'b_console_id'
const K_SUBJECT = 'b_subject_id'
const K_ACCOUNT = 'b_account_id'

export interface BConsoleSession {
  consoleId: ConsoleId | string
  subjectId: string
  accountId?: string
}

export function getBConsoleSession(): BConsoleSession | null {
  const consoleId = localStorage.getItem(K_CONSOLE)
  const subjectId = localStorage.getItem(K_SUBJECT)
  if (!consoleId || !subjectId) return null
  return {
    consoleId,
    subjectId,
    accountId: localStorage.getItem(K_ACCOUNT) || undefined
  }
}

export function setBConsoleSession(s: BConsoleSession) {
  localStorage.setItem(K_CONSOLE, s.consoleId)
  localStorage.setItem(K_SUBJECT, s.subjectId)
  if (s.accountId) localStorage.setItem(K_ACCOUNT, s.accountId)
}

export function clearBConsoleSession() {
  localStorage.removeItem(K_CONSOLE)
  localStorage.removeItem(K_SUBJECT)
  localStorage.removeItem(K_ACCOUNT)
}

/** 当前 path 是否属于会话经营台（门户守卫） */
export function isPathAllowedForConsole(path: string, consoleId: string): boolean {
  const desc = getConsole(consoleId)
  if (!desc) return false
  // 选台/入驻目录/登录 放行
  if (path.startsWith(storePath('/b/'))) return true
  if (path === storePath('/login')) return true
  if (consoleId === 'MALL_SHOP') {
    // 商城台：排除 o2o / capacity 前缀
    if (path.startsWith(storePath('/o2o')) || path.startsWith(storePath('/capacity'))) return false
    return path.startsWith(STORE_BASE)
  }
  return path.startsWith(desc.routePrefix)
}
